import cn from 'classnames';
import { HTMLAttributes } from 'react';
import { Text } from '@/shared/ui/core';
import styles from './field.module.scss';


export function FieldError ({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
    return (
        <Text
            as='p'
            size='sm'
            className={ cn(styles.error, className) }
            { ...props }
        />
    );
}
